import React, { Component } from "react"

/* Components */
import { Tag, Process, Transaction, Cards, Avatar, Notes } from "../../components"

/* Widgets */
import { Layout } from "../Table"

/* REST API */
import { game, credit, endGame } from "../../api/EPB"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Helpers */
import { utils } from "../../helpers"

/* Sweet alert */
import Swal from "sweetalert2"

/* Modal */
import Modal from "react-modal"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Moment */
import "moment/locale/ru"

/* Widget EB1 Game Information */
class EB1GameInformation extends Component {

    constructor() {
        super()

        this.state = {
            table: null,
            data: null,
            transactions: [],
            gameProcess: [],
            results: [],
            cards: [],
            status: "loading",

            visible: false,
            type: "",
            amount: "",
            waiting: false,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load Game Information */
    load = (reload = false) => {

        /* Fields */
        const { uid, gameID, operators } = this.props

        /* Validate */
        if (!uid || !gameID) {
            this.setState({ status: "error", data: null })
            return
        }

        /* Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        const ids = utils.arrayID(operators)

        /* Send request to REST API */
        game({ uid, gameID, ids }).then((response) => {
            if (response.status === 200) {
                this.setState({
                    status: "ok",
                    data: response.data.game,
                    table: response.data.table,
                    transactions: response.data.transactions,
                    gameProcess: response.data.gameProcess,
                    cards: response.data.cards,
                    results: response.data.results,
                })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: null, table: null })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: null, table: null })
            }
            else {
                this.setState({ status: "error", data: null, table: null })
            }
        }).catch(() => {
            this.setState({ status: "network", data: null, table: null })
        })

    }

    /* Get Result */
    getResult = (type) => {

        const { results } = this.state

        if (results && Array.isArray(results) && results.length > 0) {
            const index = results.findIndex((e) => e.type === type)
            if (index > -1) {
                return results[index]
            }

        }

        return null
    }


    /* Get Cards */
    getCards = (type) => {

        /* Fields */
        const { cards } = this.state
        const list = []

        if (cards && Array.isArray(cards) && cards.length > 0) {
            cards.forEach((card) => {
                if (card.type === type) {
                    list.push(card)
                }
            })
        }

        return list
    }


    /* BALANCE CALCULATION */
    calculateBalance = () => {

        const { data, transactions } = this.state

        if (data && data.startBalance) {

            let endBalance = parseFloat(data.startBalance)
            let debit = 0
            let credit = 0
            let total = 0

            if (transactions && Array.isArray(transactions) && transactions.length > 0) {
                transactions.forEach((transaction) => {
                    if (parseInt(transaction.status) === 1) {

                        if (transaction.type === "credit") {
                            endBalance = endBalance + parseFloat(transaction.total)
                            credit = credit + parseFloat(transaction.total)
                            total = total - parseFloat(transaction.total)
                        }

                        if (transaction.type === "debit") {
                            endBalance = endBalance - parseFloat(transaction.total)
                            debit = debit + parseFloat(transaction.total)
                            total = total + parseFloat(transaction.total)
                        }

                    }
                })
            }

            return {
                debit: utils.convertor(parseFloat(debit), data.symbol),
                credit: utils.convertor(parseFloat(credit), data.symbol),
                total: utils.convertor(parseFloat(total), data.symbol),
                startBalance: utils.convertor(parseFloat(data.startBalance), data.symbol),
                endBalance: parseInt(data.status) === 1 ? utils.convertor(endBalance, data.symbol) : "-",
            }

        }

        return { startBalance: "-", endBalance: "-", total: "-", debit: "-", credit: "-" }
    }



    /* End Game */
    end = (refund = false) => {

        const { data, transactions } = this.state
        const { socket, uid } = this.props

        if (parseInt(data.status) === 1) {
            return
        }

        let currency = "USD"
        if (transactions && Array.isArray(transactions) && transactions.length > 0) {
            transactions.forEach((transaction) => {
                currency = transaction.currency
            })
        }

        Swal.fire({
            title: t("widget.finishConfirm"),
            text: t("widget.finishWarning"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196f3",
            reverseButtons: true,
            confirmButtonText: t("widget.finishButton"),
            cancelButtonText: t("common.cancel"),
        }).then(async (result) => {
            if (result.isConfirmed) {

                /* With Refund */
                if (refund) {

                    let debit = 0

                    if (transactions && Array.isArray(transactions) && transactions.length > 0) {
                        transactions.forEach((transaction) => {
                            if (parseInt(transaction.status) === 1 && transaction.type === "debit") {
                                debit = debit + parseFloat(transaction.total)
                            }
                        })
                    }

                    const refund = data.refund ? parseFloat(data.refund) : 0
                    const total = debit - refund

                    if (total > 0) {
                        credit({ uid, type: "refund", refund: total, currency, playerID: data.player, roundId: data.roundId, id: data.id }).then((creditRes) => {
                            if (creditRes.status === 200) {

                                /* End Game */
                                endGame({ uid, gameID: data.id }).then((response) => {
                                    if (response.status === 200) {
                                        if (response.data.updated === "yes") {
                                            socket.emit("end", { playerID: data.player, gameID: data.id })
                                            socket.emit("adminNotification", { type: "refund", title: "Return of funds", total: refund, currency, playerID: data.player, gameID: data.id })
                                            Swal.fire(utils.notification(t("widget.finishSuccess"), "success", 3000))
                                            this.load(true)
                                        }
                                        else {
                                            Swal.fire(utils.notification(t("widget.alreadyFinished"), "error", 3000))
                                        }
                                    }
                                    else {
                                        Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                                    }
                                }).catch(() => {
                                    Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                                })

                            }
                            else {
                                this.load()
                                Swal.fire(utils.notification(t("widget.finishTxError"), "error", 4000))
                            }
                        }).catch(() => {
                            this.load()
                            Swal.fire(utils.notification(t("widget.finishTxError"), "error", 4000))
                        })
                    }
                    else {
                        Swal.fire(utils.notification(t("widget.finishTxError"), "error", 4000))
                    }

                }
                else {
                    /* End Game */
                    endGame({ uid, gameID: data.id }).then((response) => {
                        if (response.status === 200) {
                            if (response.data.updated === "yes") {
                                socket.emit("end", { playerID: data.player, gameID: data.id })
                                Swal.fire(utils.notification(t("widget.finishSuccess"), "success", 3000))
                                this.load(true)
                            }
                            else {
                                Swal.fire(utils.notification(t("widget.alreadyFinished"), "error", 3000))
                            }
                        }
                        else {
                            Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                        }
                    }).catch(() => {
                        Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                    })
                }
            }
        })
    }

    /* Refund & Pay actions */
    send = (type) => {

        const { amount, data, transactions } = this.state
        const { uid, socket } = this.props

        if (amount === null || amount === undefined || amount === "" || parseFloat(amount) === 0) {
            Swal.fire(utils.notification(t("widget.amountError"), "error"))
            return
        }

        let currency = "USD"
        if (transactions && Array.isArray(transactions) && transactions.length > 0) {
            transactions.forEach((transaction) => {
                currency = transaction.currency
            })
        }

        Swal.fire({
            title: t("widget.operationConfirm"),
            text: t("widget.finishWarning"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196f3",
            reverseButtons: true,
            confirmButtonText: t("widget.finishButton"),
            cancelButtonText: t("common.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {

                this.setState({ waiting: true })

                /* SEND TO REST API */
                credit({ uid, type, refund: amount, currency, playerID: data.player, roundId: data.roundId, id: data.id }).then((response) => {
                    if (response.status === 200) {

                        if (type === "refund") {
                            socket.emit("adminNotification", { type: "refund", title: "Return of funds", total: amount, currency, playerID: data.player, gameID: data.id })
                        }
                        else {
                            socket.emit("adminNotification", { type: "payment", title: "Replenishment of the amount", total: amount, currency, playerID: data.player, gameID: data.id })
                        }

                        Swal.fire(utils.notification(type === "refund" ? t("widget.refundSuccess") : t("widget.paySuccess"), "success"))

                    }
                    else {
                        Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                    }
                }).catch(() => {
                    Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                }).finally(() => {
                    this.load()
                    this.setState({ waiting: false, type: "", visible: false, amount: "" })
                })
            }
        })

    }

    /* Draw Payment Modal */
    _modal = () => {

        /* Fields */
        const { visible, type, amount, data, gameProcess, waiting } = this.state

        /* Game Fields */
        const balance = this.calculateBalance()
        const index = gameProcess.findIndex((p) => p.type = "ante")

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.setState({ visible: false, type: "", amount: "" })}
                className={"refund--modal"}
                overlayClassName="refund--overlay"
                closeTimeoutMS={200}
            >
                <div className="refund--modal-header">
                    <h2>{type === "refund" ? t("widget.refundTitle") : t("widget.payTitle")}</h2>
                    <div onClick={() => this.setState({ visible: false, type: "", amount: "" })} className="refund--modal-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                <div className="refund--modal-content">

                    {type === "refund" &&
                        <div className="refund--modal-information">
                            <div className="refund--modal-information-item">
                                <div className="refund--modal-information-text">{t("widget.totalBet")}</div>
                                <div className="refund--modal-information-name">{balance.debit}</div>
                            </div>
                            <div className="refund--modal-information-item">
                                <div className="refund--modal-information-text">{t("widget.refunded")}</div>
                                <div className="refund--modal-information-name">{utils.convertor(data.refund ? parseFloat(data.refund) : 0, data.symbol)}</div>
                            </div>
                        </div>
                    }

                    {type === "payment" &&
                        <div className="refund--modal-information">
                            <div className="refund--modal-information-item">
                                <div className="refund--modal-information-text">ANTE</div>
                                <div className="refund--modal-information-name">{index > -1 ? utils.convertor(gameProcess[index].total, data.symbol) : "-"}</div>
                            </div>
                            <div className="refund--modal-information-item">
                                <div className="refund--modal-information-text">{t("widget.paid")}</div>
                                <div className="refund--modal-information-name">{utils.convertor(data.paid ? parseFloat(data.paid) : 0, data.symbol)}</div>
                            </div>
                        </div>
                    }

                    <input placeholder={t("widget.amountError")} type="text" value={amount} onChange={(event) => this.setState({ amount: event.target.value.replace(/\D/, "") })} />

                    {waiting
                        ? <div className="refund--modal-button disabled"><LoadingOutlined /></div>
                        : <div className="refund--modal-button" onClick={() => this.send(type)}>{t("widget.pay")}</div>
                    }

                </div>

            </Modal>
        )
    }

    cards = (title, type) => {

        if (this.getCards(type).length > 0) {
            return <Cards title={title} cards={this.getCards(type)} result={this.getResult(type)} />
        }

        return null

    }


    render = () => {

        /* Fields */
        const { status, table, data, transactions, gameProcess } = this.state

        /* Preloaders */
        if (status !== "ok") {
            return (
                <div className='eb1--game-inner'>
                    <Layout status={status} reload={() => this.load(true)} />
                </div>
            )
        }

        /* Game Fields */
        const balance = this.calculateBalance()
        const datetime = utils.getTime(data.createdAt)

        return (
            <div className="eb1--game-inner">
                <div className="eb1--game-information">
                    <div className="eb1--game-information-row">

                        {/* Game Information */}
                        <div className="eb1--game-information-element">

                            {/* Name */}
                            <div className="eb1--game-information-item">
                                <img src="/images/game/spades.png" alt="Spades" />
                                <div className="eb1--game-information-item-box">
                                    <div className="eb1--game-information-item-title">{t("widget.game")}</div>
                                    <div className="eb1--game-information-item-text">{table.name}</div>
                                </div>
                            </div>

                            {/* Number */}
                            <div className="eb1--game-information-item">
                                <img src="/images/game/shape.png" alt="Shape" />
                                <div className="eb1--game-information-item-box">
                                    <div className="eb1--game-information-item-title">{t("widget.gameNumber2")}</div>
                                    <div className="eb1--game-information-item-text">{data.number}</div>
                                </div>
                            </div>

                            {/* Date */}
                            <div className="eb1--game-information-item">
                                <img src="/images/game/clock.png" alt="Clock" />
                                <div className="eb1--game-information-item-box">
                                    <div className="eb1--game-information-item-title">{t("widget.date")}</div>
                                    <div className="eb1--game-information-item-text">{datetime.time}, <span>{datetime.date}</span></div>
                                </div>
                            </div>

                            {/* Player */}
                            <div className="eb1--game-information-item">
                                <Avatar uri="/images/player/gamer.png" size={24} />
                                <div className="eb1--game-information-item-box">
                                    <div className="eb1--game-information-item-title">{t("widget.player")} {data.player}</div>
                                    <div className="eb1--game-information-item-text">{data.firstName}</div>
                                </div>
                            </div>

                            {/* Game Status */}
                            <div className="eb1--game-information-item">
                                <img src="/images/game/flag.png" alt="Flag" />
                                <div className="eb1--game-information-item-box">
                                    <div className="eb1--game-information-item-title">{t("widget.gameStatus")}</div>
                                    {parseInt(data.status) === 1 ? <Tag color="blue">{t("widget.completed")}</Tag> : <Tag color="purple">{t("widget.notCompleted")}</Tag>}
                                </div>
                            </div>

                        </div>


                        {/* Player Information */}
                        <div className='eb1--game-information-element'>

                            {/* Debit */}
                            <div className="eb1--game-information-item">
                                <img src="/images/game/increase.png" alt="Increase" />
                                <div className="eb1--game-information-item-box">
                                    <div className="eb1--game-information-item-title">Debit</div>
                                    <div className="eb1--game-information-item-text">{balance.debit}</div>
                                </div>
                            </div>

                            {/* Debit */}
                            <div className="eb1--game-information-item">
                                <img src="/images/game/decrease.png" alt="Decrease" />
                                <div className="eb1--game-information-item-box">
                                    <div className="eb1--game-information-item-title">Credit</div>
                                    <div className="eb1--game-information-item-text">{balance.credit}</div>
                                </div>
                            </div>

                            {/* Calculate */}
                            <div className="eb1--game-information-item">
                                <img src="/images/game/calculate.png" alt="Calculate" />
                                <div className="eb1--game-information-item-box">
                                    <div className="eb1--game-information-item-title">{t("widget.total")}</div>
                                    <div className="eb1--game-information-item-text">{balance.total}</div>
                                </div>
                            </div>

                            {/* Start Balance */}
                            <div className="eb1--game-information-item">
                                <img src="/images/game/dollar-coin.png" alt="Dollar" />
                                <div className="eb1--game-information-item-box">
                                    <div className="eb1--game-information-item-title">{t("widget.balanceBefore")}</div>
                                    <div className="eb1--game-information-item-text">{balance.startBalance}</div>
                                </div>
                            </div>

                            {/* End Balance */}
                            <div className="eb1--game-information-item">
                                <img src="/images/game/dollar-coin.png" alt="Dollar" />
                                <div className="eb1--game-information-item-box">
                                    <div className="eb1--game-information-item-title">{t("widget.balanceAfter")}</div>
                                    <div className="eb1--game-information-item-text">{balance.endBalance}</div>
                                </div>
                            </div>

                        </div>


                        <div className='eb1--game-information-big-element'>

                            <div className="eb1--game-information-text">Game actions</div>

                            <div className="eb1--game-buttons">
                                <div onClick={() => this.end()} className={`eb1--game-button ${parseInt(data.status) === 1 ? "disabled" : ""}`} >{t("widget.finishGame")}</div>
                                <div onClick={() => this.end(true)} className={`eb1--game-button gray ${parseInt(data.status) === 1 ? "disabled" : ""}`} >{t("widget.finishAndRefund")}</div>
                            </div>

                            <div className="eb1--game-information-text">Payment actions</div>

                            <div className="eb1--game-buttons">
                                <div onClick={() => this.setState({ visible: true, type: "refund" })} className="eb1--game-button purple">{t("widget.refundTitle")}</div>
                                <div onClick={() => this.setState({ visible: true, type: "payment" })} className="eb1--game-button pink">{t("widget.payTitle")}</div>
                            </div>

                        </div>

                    </div>

                    {/* Processes */}
                    <Process count={2} symbol={data.symbol} data={gameProcess} />

                    {/* Transactions */}
                    <Transaction symbol={data.symbol} data={transactions} />

                    {/* Cards */}
                    <div className="cards--container">
                        {this.cards("Banker Cards", "banker")}
                        {this.cards("Player Cards", "player")}
                    </div>

                    {/* Payment Modal */}
                    {this._modal()}

                </div>

                <Notes uid={table.uid} gameID={data.id} />

            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        operators: state.operators,
        language: state.language,
    }
}

export default connect(mapStateToProps)(EB1GameInformation)